import React, { useEffect } from "react";
import { LandingHeader } from "../components/landing/LandingHeader";
import { LandingHero } from "../components/landing/LandingHero";
import { LandingFeatures, LandingBenefits, LandingSteps } from "../components/landing/LandingSections";
import { LandingShowcase } from "../components/landing/LandingShowcase";
import { LandingWhatsNew } from "../components/landing/LandingWhatsNew";
import { LandingGiftCards } from "../components/landing/LandingGiftCards";
import { LandingPillars } from "../components/landing/LandingPillars";
import { LandingLogin } from "../components/landing/LandingLogin";
import { LandingDemo } from "../components/landing/LandingDemo";
import { LandingStudio } from "../components/landing/LandingStudio";
import { LandingFooter } from "../components/landing/LandingFooter";
import { trackShowcase } from "./CircuitsShowcase";

// Landing nouvellefidelity.it: presentazione del servizio + login operatori + richiesta demo
export default function PlatformLanding() {
  useEffect(() => {
    trackShowcase("visit");
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "smooth";
    return () => { document.documentElement.style.scrollBehavior = prev; };
  }, []);
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="platform-landing">
      <LandingHeader />
      <main>
        <LandingHero />
        <LandingFeatures />
        <LandingWhatsNew />
        <LandingShowcase />
        <LandingPillars />
        <LandingGiftCards />
        <LandingBenefits />
        <LandingSteps />
        <LandingLogin />
        <LandingDemo />
        <LandingStudio />
      </main>
      <LandingFooter />
    </div>
  );
}
